import React, { useEffect } from 'react';
import { Heading, VStack, SimpleGrid, Text } from '@chakra-ui/react';
import type { NextPage } from 'next';
import NextHead from 'next/head';
import type { Props as ServerSideProps } from '../server/serverSideProps/weeklyRankingArticles';
import ArticlesGrid from '../components/ArticlesGrid';
import { sendAnalyticsEvent } from '../common/libs/googleAnalytics';
import { title } from '../common/libs/metadata';
import { getPublicRuntimeConfig } from '../common/config';

export { getServerSideProps } from '../server/serverSideProps/weeklyRankingArticles';

const WeeklyRankingArticlesPage: NextPage<ServerSideProps> = ({
  weeklyRankingArticles,
  isMobile,
}) => {
  // マウント時にイベント送信
  useEffect(() => {
    sendAnalyticsEvent('slide', 'index', 'weekly_ranking');
  }, []);

  const { slideWebBaseUrl } = getPublicRuntimeConfig();
  const canonicalUrl = `${slideWebBaseUrl}/weekly-ranking-articles`;

  return (
    <>
      <NextHead>
        <title>{title('週間スライドランキング')}</title>
        <link rel="canonical" href={canonicalUrl} />
      </NextHead>
      <VStack
        spacing={4}
        px={{
          base: 4,
          sm: 6,
          xl: 0,
        }}
        align="flex-start"
      >
        <Heading as="h1" fontSize="2xl">
          週間スライドランキング
        </Heading>
        <Text color="gray">
          直近90日以内に投稿されたスライドを対象に閲覧数の多いスライド上位20件を表示しています
        </Text>
        <ArticlesGrid
          articles={weeklyRankingArticles}
          isMobile={isMobile}
          gaEventLabel={(article) =>
            `weekly_ranking_${article?.rankingNumber}_from_slides`
          }
          onShowThumbnail={(articleId) => {
            sendAnalyticsEvent(
              'slide_thumbnail',
              'show',
              `weeklyRankingArticles#${articleId}`,
            );
          }}
          onClick={(articleId) => {
            sendAnalyticsEvent(
              'slide_thumbnail',
              'click',
              `weeklyRankingArticles#${articleId}`,
            );
          }}
        />
      </VStack>
    </>
  );
};

export default WeeklyRankingArticlesPage;
